import { useState } from "react";

export function MatchTeamLogo({
  name,
  logoUrl,
  className = "",
}: {
  name: string;
  logoUrl: string | null;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const initials = name
    .split(/\s+/)
    .map((part) => part.charAt(0).toUpperCase())
    .filter(Boolean)
    .slice(0, 2)
    .join("");

  return (
    <span
      className={`match-team-logo inline-flex h-7 w-7 shrink-0 items-center justify-center overflow-hidden rounded border text-[0.6rem] font-display text-ink-muted ${logoUrl && !failed ? "border-transparent bg-transparent" : "border-rule bg-canvas"} ${className}`}
      data-testid="match-team-logo"
      data-has-logo={logoUrl && !failed ? "true" : "false"}
      aria-hidden="true"
    >
      {logoUrl && !failed ? (
        <img
          src={logoUrl}
          alt=""
          loading="lazy"
          className="h-full w-full object-contain"
          onError={() => setFailed(true)}
        />
      ) : (
        initials || "?"
      )}
    </span>
  );
}
